import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditCatalogModules from './EditCatalogModules'
import ListCatalogModules from './ListCatalogModules'
import NewCatalogModules from './NewCatalogModules'

const AdminCatalogModulesRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListCatalogModules /></PrivateRoute7>} />
        <Route path="edit-catalog-module" element={<PrivateRoute7><EditCatalogModules /></PrivateRoute7>} />
        <Route path="new-catalog-module" element={<PrivateRoute7><NewCatalogModules /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminCatalogModulesRoutes